module.exports = __webpack_public_path__ + "static/media/locationIcon.82e0f10a.svg";